// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"b53ab7c8","205":"49c0f2ba","292":"fc68c026","502":"0dce9ba0","551":"c55460b3","631":"14433396","672":"29419fee","842":"29d38769"}[chunkId] + ".chunk.js";
};